export function globalColorFireQuotation(status: string) {
    switch (status) {
        case "open":
            return { bg: "#E6FAF9", color: "#00A6A6" }; // ciano leve
        case "pending":
            return { bg: "#FFF3E0", color: "#D97904" }; // laranja suave
        case "hired":
            return { bg: "#E8F5E9", color: "#4CAF50" }; // verde leve
        case "canceled":
            return { bg: "#FDEAEA", color: "#E53935" }; // vermelho suave
        case "expired":
            return { bg: "#E1F5FE", color: "#0288D1" }; // azul extrajudicial
        default:
            return { bg: "#ECECEC", color: "#757575" }; // cinza padrão
    }
}